// SheetComponentUnits.jsx
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import UniversalComponent from '../component/UniversalComponent.jsx';

import { ButtonId } from '../resource/mixpanel.js';
import { NULL_FUNCTION, EMPTY_OBJECT } from '../resource/defaults.js';

import { color } from '../style/variables.js';
import media from '../style/media.js';
import ResetButtonStyle from '../style/ResetButtonStyle.js';
import TextEllipsis from '../style/TextEllipsis.js';
import FadeIn from '../style/FadeIn.js';
import FadeOut from '../style/FadeOut.js';

import CloseIconSource from '../../img/ic_topbar_close_grey.svg';

export const SheetBackdrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ isShowOverlay }) =>
    isShowOverlay ? 'rgba(0, 0, 0, 0.7)' : 'transparent'};
  pointer-events: ${({ needBackdrop }) => (needBackdrop ? 'auto' : 'none')};
  animation: 0.6s forwards
    ${({ modalStatus }) => ('closing' === modalStatus ? FadeOut : FadeIn)};
  ${({ backdropCss }) => backdropCss};
`;

export const Sheet = styled.div`
  position: absolute;
  border-radius: 8px;
  width: 100%;
  max-width: 360px;
  max-height: 80vh;
  max-height: 80dvh;
  background-color: ${color.neutral[10]};
  box-shadow: 0px 4px 16px 2px #00000066;
  // sheet position might have these styles and these styles come from SheetComponent.
  // * bottom
  // * right
  // * transform
  ${({ sheetPosition }) => ({ ...sheetPosition })}

  ${media.tablet`
    bottom: 0;
    left: 50%;
    right: auto;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    max-width: 576px;
    transform: translateX(-50%);
  `};

  ${media.mobile`
    bottom: 0;
    left: 50%;
    right: auto;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    max-width: none;
    transform: translateX(-50%);
  `};

  ${({ sheetCss }) => sheetCss};
`;

export const SheetHeader = styled.div`
  position: relative;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  ${media.tablet`
    padding: 8px 48px 8px 16px;
  `};
  ${media.mobile`
    padding: 8px 48px 8px 16px;
  `};
`;

export const SheetHeaderTitle = styled.div`
  ${TextEllipsis};
  font-size: 18px;
  font-weight: 600;
  color: ${color.neutral[100]};
  line-height: 1.5;
  ${media.tablet`
    font-size: 16px;
  `};
  ${media.mobile`
    font-size: 16px;
  `};
`;

export const SheetHeaderCloseButton = ({
  onClick = NULL_FUNCTION,
  trackingButtonId = ButtonId.All.ButtonClose,
  trackingPayload = EMPTY_OBJECT,
}) => {
  return (
    <CloseButton
      onClick={onClick}
      data-element_id={trackingButtonId}
      data-tracking_payload={trackingPayload}
    >
      <img src={CloseIconSource} alt="close" />
    </CloseButton>
  );
};

SheetHeaderCloseButton.propTypes = {
  trackingButtonId: PropTypes.string,
  trackingPayload: PropTypes.object,
  onClick: PropTypes.func,
};

const CloseButton = styled.button`
  ${ResetButtonStyle};
  position: absolute;
  top: 50%;
  right: 8px;
  width: 32px;
  height: 32px;
  display: none;
  align-items: center;
  justify-content: center;
  transform: translateY(-50%);

  > img {
    width: 20px;
    height: 20px;
    object-fit: contain;
  }

  ${media.tablet`
    display: flex;
  `};
  ${media.mobile`
    display: flex;
  `};
`;

export const SheetHeaderDiamond = () => {
  return (
    <SheetHeaderDiamondContainer>
      <UniversalComponent
        filename="Container_Diamond"
        importer={/* #__LOADABLE__ */ () => import('../container/Diamond.js')}
      />
    </SheetHeaderDiamondContainer>
  );
};

const SheetHeaderDiamondContainer = styled.div`
  margin-left: 8px;
  flex: none;
  display: none;
  align-items: center;
  ${media.tablet`
    display: flex;
  `};
`;
